import React,{useState} from 'react'
import './SearchFilters.css';
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css';

const SearchFilters = ({type,setType}) => {

    var [priceVal,setPriceVal] = useState([0,0])
    var [sizeVal,setSizeVal] = useState([0,0])
    var [passengers,setPassengers] = useState(0)
    var [boatType,setBoatType] = useState('')
    
    return (
    <div className='SearchFiltersMain'>

        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='price'){
                    setType('')
                }else{
                    setType('price')
                }
            }}>
                Price
            </button>
            <div className={type=='price' ? 'show' : 'hide'}>
                <p>Price per hours</p>
                <Slider
                range
                min={0}
                max={1000}
                onChange={val=>setPriceVal(val)}
                allowCross={false}
                className='slider'
                // defaultValue={10}
                />
            <p>{priceVal[0]}$ - {priceVal[1]}$</p>
            </div>
        </div>
        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='size'){
                    setType('')
                }else{
                    setType('size')
                }
            }}>
                Size
            </button>
            <div className={type=='size' ? 'show' : 'hide'}>
            <p>Size as per feets</p>
                <Slider
                range
                min={0}
                max={50}
                onChange={val=>setSizeVal(val)}
                allowCross={false}
                className='slider'
                // defaultValue={10}
                />
            <p>{sizeVal[0]}ft - {sizeVal[1]}ft</p>

            </div>
        </div>
        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='dur'){
                    setType('')
                }else{
                    setType('dur')
                }
            }}>
                Duration
            </button>
            <div className={type=='dur' ? 'show' : 'hide'}>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Day Charter</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Multi Day Charter </p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Week Charter </p>
            </div>
        </div>
        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='pass'){
                    setType('')
                }else{
                    setType('pass')
                }
            }}>
                Passengers
            </button>
            <div className={type=='pass' ? 'show' : 'hide'} style={{width:'250px'}}>
            <p>Number of pasengers</p>
            <div className='passSubDiv'>
                <button onClick={()=>setPassengers(passengers-1)} className='minusplus'>-</button>
                <span>{passengers}</span>
                <button onClick={()=>setPassengers(passengers+1)} className='minusplus'>+</button>
            </div>
            </div>
        </div>
        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='type'){
                    setType('')
                }else{
                    setType('type')
                }
            }}>
                Type
            </button>
            <div className={type=='type' ? 'show boat' : 'hide boat'} style={{width:'250px'}}>
            <p>Type of boat</p>
            <div className='typeSubDiv'>
                <button 
                onClick={()=>setBoatType('power')}
                className={boatType=='power' ? 'minusplus' : ' minusplus deactiveTypeBtn'}>Power</button>
                <span>or</span>
                <button
                onClick={()=>setBoatType('sail')}
                 className={boatType=='sail' ? 'minusplus' : ' minusplus deactiveTypeBtn'}>Sail</button>
            </div>
            </div>
        </div>
        <div className='filterDivDiv'>
            <button onClick={()=>{
                if(type=='ava'){
                    setType('')
                }else{
                    setType('ava')
                }
            }}>
                Availability
            </button>
            <div className={type=='ava' ? 'show ava' : 'hide ava'} style={{width:'200px'}}>
            <p>Availability</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Monday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Tuesday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Wednesday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Thursday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Friday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Saturday</p>
                <p className='dur_p'> <input type='checkbox' className='chkbox' /> Sunday</p>
            </div>
        </div>

    </div>
  )

}

export default SearchFilters